import React, { Component } from "react";
import "./styles/Footer.css";

class Footer extends Component {
  render() {
    return (
      <div id="footer"></div>
    );
  }
}

export default Footer;
